import React from "react";
import {
  Grid,
  makeStyles,
  Typography,
  Paper,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import useError from "Hooks/useError";
import MuiAlert from "@material-ui/lab/Alert";
import { message } from "constants/message";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  messsageWrapper: {
    marginTop: theme.spacing(1),
  },
}));

export default function Form({ submit, user = null, isEdit = false }) {
  const classes = useStyles();
  const stateError = useError();
  const messages = message();
  const [name, setName] = React.useState("");
  const [desc, setDesc] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [userType, setUserType] = React.useState("admin");

  React.useEffect(() => {
    stateError.initialize();
  }, []);
  
  React.useEffect(() => {
    if (!user) return;
    setName(user.name);
    setDesc(user.desc);
    setEmail(user.email);
    setUserType(user.user_type ? user.user_type : "admin");
  }, [user]);

  // パスワード入力形式確認用バリデーションを追加
  ValidatorForm.addValidationRule('checkPassword', (value) => {
    if (!value) return true; 
    // パスワードの正規表現
    //   (?=.*?[\u0021-\u002f\u003a-\u0040\u005b-\u0060\u007b-\u007e]) # lookahead punctuations
    //   (?=.*?[\u0030-\u0039])                                        # lookahead digits
    //   (?=.*?[\u0041-\u005a])                                        # lookahead upper case alphabets
    //   (?=.*?[\u0061-\u007a])                                        # lookahead lower case alphabets
    //   [\u0021-\u007e]{8,32}                                         # 8 to 32 of ascii printables
    const regexp = /^((?=.*?[\u0021-\u002f\u003a-\u0040\u005b-\u0060\u007b-\u007e])(?=.*?[\u0030-\u0039])(?=.*?[\u0041-\u005a])(?=.*?[\u0061-\u007a])([\u0021-\u007e]{8,32}))$/;

    if (!regexp.test(value)) {
      return false;
    } else {
      return true;
    }
  });

  const onError = () => {
    stateError.dispatch({
      type: "set",
      payload: {
        isError: true,
        errorMsg: messages.validation.common,
      },
    });
  };

  return (
    <Grid>
      <ValidatorForm
        onSubmit={(e) => {
          e.preventDefault();
          submit({ name, desc, email, password, userType });
        }}
        onError={onError}
      >
        <Paper elevation={3} className={classes.paper}>
          <Typography variant="h6" color="primary">
            {isEdit ? "ユーザ更新" : "ユーザ登録"}
          </Typography>
          <Grid item xs={12} className={classes.wrapper}>
            <TextValidator
              label="ユーザ名*"
              fullWidth
              value={name}
              onChange={(event) => {
                setName(event.target.value);
              }}
              validators={['required']}
              errorMessages={[messages.validation.required]}
            />
          </Grid>
          <Grid item xs={12} className={classes.wrapper}>
            <TextValidator
              label="ユーザ概要"
              fullWidth
              value={desc}
              onChange={(event) => {
                setDesc(event.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} className={classes.wrapper}>
            <TextValidator
              label="メールアドレス*"
              fullWidth
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
              }}
              type="email"
              validators={['required', 'isEmail']}
              errorMessages={[
                messages.validation.required, 
                messages.validation.isEmail, 
              ]}
            />
          </Grid>
          {!isEdit && (
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="パスワード*"
                fullWidth
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
                type="password"
                autoComplete="new-password"
                validators={['required', 'checkPassword']}
                errorMessages={[
                  messages.validation.required,
                  messages.validation.isPasswordRegexp
                ]}
              />
            </Grid>
          )}
          <Grid item xs={12} className={classes.wrapper}>
            <FormControl component="fieldset">
              <FormLabel component="legend">権限</FormLabel>
              <RadioGroup
                row
                aria-label="user_type"
                name="user_type"
                value={userType}
                onChange={(event) => {
                  setUserType(event.target.value);
                }}
              >
                <FormControlLabel
                  value="admin"
                  control={<Radio required={true} />}
                  label={"管理者"}
                />
                <FormControlLabel
                  value="normal"
                  control={<Radio required={true} />}
                  label="一般"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Paper>

        {stateError.state.isError && (
          <div className={classes.messsageWrapper}>
            <MuiAlert
              elevation={6}
              variant="filled"
              severity="error"
              className={classes.toast}
            >
              {stateError.state.errorMsg}
            </MuiAlert>
          </div>
        )}
        <Grid container justifyContent="center" className={classes.wrapper}>
          <Button type="submit" variant="contained" color="primary">
            {isEdit ? "更新" : "登録"}
          </Button>
        </Grid>
      </ValidatorForm>
    </Grid>
  );
}
